import React from 'react'
import {Jumbotron} from './components/Jumbotron';
import styled from 'styled-components';
import {Layout} from './components/Layout';
import {Container} from 'react-bootstrap';
import {SocialIcon} from 'react-social-icons';
import {ReactDOM} from 'react-dom';


const Styles=styled.div`

@media only screen and (max-width: 1000px) {
.headshot{
float:left;
max-width:80%;
height:auto;
border: 2px solid black;
margin-left:25px;
margin-bottom:25px;
}
.text{
margin-left:30px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-right:40px;
margin-top:80px;
}

.socials{
float:right;
margin-bottom:200px;
}
}
@media only screen and (min-width:1001px){
.headshot{
float:left;
width:30%;
height:auto;
border: 2px solid black;
margin-left:25px;
margin-bottom:100px;
margin-right:40px;
}

.text{
margin-left:30px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-right:40px;
margin-top:80px;


.socials{
float:right;
margin-bottom:200px;
margin-right:60px;
}

}
`;

export const Home = ()=> (

<React.Fragment>		
	<Jumbotron />
<Styles>
	<body>
	<img src={require('./assets/headshot.jpg')} alt="headshot" Class="headshot"/> 
	<div class="text">
	<p>Hi! I'm Jay, and I'm a technology product and program manager based in Huntsville, AL. I have a passion for building digital experiences that delight customers and corporate teams alike. I graduated from the University of Alabama in Huntsville with a BBA in Management Information Systems in 2016, and since then, I've been leading project teams and spearheading new initiatives across a range of industries </p>

	<p> Currently, I serve as a Product Manager for <a href="http://www.invitationhomes.com/">Invitation Homes</a>, where I'm focused on enhancing the company's associate digital experience. I'm working to develop innovative solutions that empower associates to execute their roles with confidence, efficiency, and accuracy. </p>
		
	<p> Whether I'm collaborating with cross-functional teams, analyzing user data, or conducting market research, I'm always driven by a desire to create value and make a meaningful impact in the world of technology. </p>


	<br></br><br></br><p Style="text-align:right; margin-right:60px;"> You can find me online here:</p>
	<div className="socials">
	<SocialIcon url="http://twitter.com/jay_topiwala"/>
	<SocialIcon url="http://www.linkedin.com/in/jaytopiwala"/>
	<SocialIcon url="http://www.instagram.com/jaytopiwala"/>	
	<SocialIcon url="mailto:jayhtopiwala@gmail.com"/>

	
	</div>
	</div>
</body>
</Styles>

	</React.Fragment>

) 